import React from 'react';
import {Col, Row} from 'react-bootstrap';

const PricesPage = () => {
    return (
        <>
            <h4 className="mb-4">Cenník služieb</h4>

            <Row className="mb-3">
                <Col xs={12} md={8}>
                    Základný vstup „Open Gym“ (60 min)
                </Col>
                <Col xs={12} md={4} className="text-md-end">
                    5€
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={8}>
                    Individuálny tréning s trénerom (55 min)
                </Col>
                <Col xs={12} md={4} className="text-md-end">
                    25€
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={8}>
                    Vstup “Premium” (prenájom fitness zóny na súkromný tréning, 60 min)
                </Col>
                <Col xs={12} md={4} className="text-md-end">
                    25€
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={8}>
                    Skupinový/kruhový tréning s trénerom (55 min)
                </Col>
                <Col xs={12} md={4} className="text-md-end">
                    8€
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={8}>
                    Inbody – úvodné meranie s konzultáciou (15 min)
                </Col>
                <Col xs={12} md={4} className="text-md-end">
                    20€
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={8}>
                    Inbody balík – 3x kontrolné meranie bez konzultácie
                </Col>
                <Col xs={12} md={4} className="text-md-end">
                    45€
                </Col>
            </Row>
        </>
    );
}

export default PricesPage;
